import script from "./ButtonFixedPrimary.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonFixedPrimary.vue?vue&type=script&setup=true&lang=js"

import "./ButtonFixedPrimary.vue?vue&type=style&index=0&id=db2fa402&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db2fa402"]])

export default __exports__